import React, { useState, useEffect } from 'react';
import _ from 'lodash'
import { useHistory } from 'react-router-dom';
import FormContributors from './FormContributors'
import LineUser from './LineUser'
import styles from './contributors.module.scss';
import useQuery from '../../../../customHooks/useQuery';

import { useGlobalContext } from '../../../GlobalContext'
import { getLunchPaymentStatus } from '../../../../actions/payment'
import { getCompany } from '../../../../actions/company'

export default function Contributors(){
  const [context, dispatch] = useGlobalContext();
  const companyReducer = context.companyReducer;
  const query = useQuery();
  const history = useHistory();

  const [ selectedUser, setSelectedUser ] = useState()
  const [ users, setUsers ] = useState()
  const [ isFormContactOpen, setIsFormContactOpen ] = useState(false)
  const [ lunchPaymentReadyEmail, setLunchPaymentReadyEmail ] = useState(null)
  const [ lunchPaymentPaidDays, setLunchPaymentPaidDays ] = useState([])

  useEffect(()=>{
    if(!companyReducer.companyUsers) return;
    let sortedUsers = _.sortBy(companyReducer.companyUsers,(d)=>d.role === "Owner").reverse()
    setUsers(sortedUsers)
  },[companyReducer.companyUsers])

  useEffect(() => {
    async function handleLunchPaymentReturn() {
      const paymentStatus = query.get('lunch_payment');
      const sessionId = query.get('session_id');

      if (paymentStatus === 'success' && sessionId) {
        const res = await getLunchPaymentStatus(dispatch, sessionId);
        if (res?.lunchPaid) {
          const companyId = companyReducer.company?._id;
          if (companyId) {
            await getCompany(dispatch, companyId);
          }
          setLunchPaymentReadyEmail(res.email);
          setLunchPaymentPaidDays(res.paidDates || res.lunchPaidDays || []);
          if (res.userId) {
            setSelectedUser(res.userId);
            setIsFormContactOpen(false);
          } else {
            setSelectedUser(null);
            setIsFormContactOpen(true);
          }
        }
        history.replace('/contributors');
      } else if (paymentStatus === 'cancel') {
        setSelectedUser(null);
        setIsFormContactOpen(true);
        history.replace('/contributors');
      }
    }

    handleLunchPaymentReturn();
    // eslint-disable-next-line
  }, []);

  function selectUser(id){
    setSelectedUser(id)
    setIsFormContactOpen(false)
    setLunchPaymentReadyEmail(null)
    setLunchPaymentPaidDays([])
  }

  function toggleModal(){
    setSelectedUser(null)
    setIsFormContactOpen(!isFormContactOpen)
    setLunchPaymentReadyEmail(null)
    setLunchPaymentPaidDays([])
  }

  function cancel(){
    setSelectedUser(null)
    setIsFormContactOpen(false)
    setLunchPaymentReadyEmail(null)
    setLunchPaymentPaidDays([])
  }

  function getSortedUsers() {
    if (!companyReducer.companyUsers) return users || [];
    return _.sortBy(companyReducer.companyUsers, (d) => d.role === "Owner").reverse();
  }

  function renderListUsers(){
    const sortedUsers = getSortedUsers();
    if(!sortedUsers?.length) return null;
    return (
      <>
        { sortedUsers.map((user, i)=>(
          <LineUser key={"user-"+i}
           user={companyReducer.companyUsers?.find((u) => u._id === user._id) || user}
           isLoading={companyReducer.isUserLoading ? companyReducer.isUserLoading.map.get(user._id) : null}
           cancel={() => cancel()}
           selectUser={selectUser}
           selectedUser={selectedUser}
           edit={selectedUser === user._id}
           lunchPaymentReadyEmail={lunchPaymentReadyEmail}
           lunchPaymentPaidDays={lunchPaymentPaidDays}
          />
        ))}
      </>
    )
  }


  function fnIsLoading(){
    let isLoading = null;
    if(companyReducer.isUserLoading){
      isLoading = companyReducer.isUserLoading.map.get("update-contributors") || companyReducer.isUserLoading.map.get("add") ? true : null
    }
    return isLoading
  }


  return (
    <>
      <div className={styles.contributors}>
        <div className="content large">
          <div className="title-page">
            <h2>Mes collaborateurs</h2>
          </div>
          <p className={styles['section-title']}>Inscrire les collaborateurs présents</p>
          {renderListUsers()}

          {!isFormContactOpen && getSortedUsers().length > 0 && !selectedUser ?
            <div className="centered">
              <div className={styles['addContact']} onClick={toggleModal}>
                <p >Ajouter un contact</p>
                <div className={styles.add} >+ </div>
              </div>
            </div> : null
          }

          { isFormContactOpen || getSortedUsers().length === 0 ?
            <FormContributors
             isLoading={fnIsLoading()}
             cancel={() => cancel()}
             lunchPaymentReadyEmail={lunchPaymentReadyEmail}
             lunchPaymentPaidDays={lunchPaymentPaidDays}
            /> : null
          }
        </div>
      </div>
    </>
  )
}
